export default __webpack_public_path__ + "static/media/kisfalvi_bence.39bff0d5.jpeg";